import React from 'react';
import { Spacer as Spacing } from '@sparknz/spark-pattern-library';

import { SpacerEditConfig, SpacerProps } from './SpacerConfig';

const Spacer = (props: React.PropsWithChildren<SpacerProps>) => {
  if (SpacerEditConfig.isEmpty(props)) {
    return null;
  }
  const { tokenName } = props;

  return <Spacing variant={tokenName} />;
};

export default Spacer;
